<div class="flex flex-col gap-6 bg-lGray900 rounded-2xl p-5 sm:p-6">
  <h2 class="text-2xl font-medium text-lWhite">Informações Pessoais</h2>

  <form [formGroup]="formGroup" class="grid grid-cols-1 gap-6 sm:grid-cols-2">
    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="name"
          formControlName="name"
          autocomplete="off"
          class="w-full"
        />
        <label for="name">Nome</label>
      </p-floatlabel>
    </div>

    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="birthDate"
          formControlName="birthDate"
          autocomplete="off"
          class="w-full"
          [mask]="dateMask"
          [dropSpecialCharacters]="false"
          [validation]="false"
        />
        <label for="birthDate">Data de aniversário</label>
      </p-floatlabel>
    </div>

    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="email"
          formControlName="email"
          autocomplete="off"
          class="w-full"
        />
        <label for="email">Email</label>
      </p-floatlabel>
    </div>

    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="phone"
          formControlName="phone"
          autocomplete="off"
          class="w-full"
          [mask]="phoneMask"
          [dropSpecialCharacters]="false"
          [validation]="false"
        />
        <label for="phone">Celular</label>
      </p-floatlabel>
    </div>

    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="cpfCnpj"
          formControlName="cpfCnpj"
          autocomplete="off"
          class="w-full"
          [mask]="cpfCnpjMask"
          [dropSpecialCharacters]="false"
          [validation]="false"
        />
        <label for="cpfCnpj">CPF/CNPJ</label>
      </p-floatlabel>
    </div>

    <div>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="institution"
          formControlName="institution"
          autocomplete="off"
          class="w-full"
        />
        <label for="institution">Instituição</label>
      </p-floatlabel>
    </div>
  </form>  
</div>

<div class="flex flex-col-reverse gap-3 pt-4 sm:flex-row sm:justify-end">
  @if (isEditing) {
    <button
      lButton
      [bType]="buttonTypeEnum.PRIMARY"
      [outline]="true"
      [bRadius]="buttonRadiusEnum.CIRCLE"
      type="button"
      [disabled]="isSaving"
      (click)="cancelEdit()"
      class="sm:!w-52"
    >
      Cancelar
    </button>
  }

  <button
    lButton
    [bType]="buttonTypeEnum.PRIMARY"
    [bRadius]="buttonRadiusEnum.CIRCLE"
    type="button"
    [disabled]="isSaving"
    (click)="isEditing ? saveInformation() : toggleEditMode()"
    class="sm:!w-52"
  >
    {{ isEditing ? 'Salvar alterações' : 'Editar Perfil' }}
  </button>
</div>
